import type { StepperVerticalProps } from './stepperVerticalTypes'

import { styled } from '../core'
import { stepClassName, tailClassName } from './consts'

const StepperVerticalBase = styled.divBox<StepperVerticalProps>`
  width: 100%;

  .${stepClassName}:last-of-type > .${tailClassName} {
    display: none;
  }
`
export default StepperVerticalBase
